import { useMemo } from "react";
import { QrAnalyticsPage } from "@wedding/qr-analytics";
import { useWedding } from "../contexts/wedding-context";
import { createAdminAnalyticsApi } from "../lib/api";

/**
 * Admin adapter for the shared QR-analytics page (per-wedding). Same UI as the
 * organizer — the single source of truth lives in `@wedding/qr-analytics`; only
 * the API client (admin auth) + wedding context differ.
 */
export function WeddingAnalyticsPage() {
  const { wedding, slug } = useWedding();
  const api = useMemo(() => createAdminAnalyticsApi(slug), [slug]);
  return <QrAnalyticsPage slug={slug} wedding={wedding} api={api} />;
}
